import React, { useEffect, useState } from "react";

// framework and libarry
import { Row, Col, Card, Form, Table, Button, Badge, Modal } from "react-bootstrap";
import moment from "moment";
import { useLazyQuery, useMutation } from "@apollo/client";
import _ from "lodash";

import "../../../styles/claimTable.css";

// components
import { COLOR_TEXT, COLOR_WHITE } from "../../../constants";
import ModalConfirmComponent from "../../../components/ModalConfirmComponent";
import LoadingSpinner from "../../../components/LoadingSpinner";
import CurrentDateModal from "../../../components/currentComponent/CurrentDateModal";
import { convertCurrentDate, convertStatusInvoiceClaim, numberFormat, splitDateTime } from "../../../helpers";
import { GET_INVOICE_CREDITS } from "../../../graphql/wallet/query";
import { CANCELED_INVOICE_CREDIT } from "../../../graphql/wallet/mutation";

//  icons 
import { MdAdd, MdCancel, MdDateRange, MdRefresh, MdSearch } from "react-icons/md";
import EmptyCredit from "../claim/EmptyCredit";
import InvoiceDetail from "./InvoiceDetail";
import PaginationHelper from "../../../helpers/PaginationHelper";
import { IoMdEye } from "react-icons/io";



export default function InvoiceCreditLists() {
    
    const [invoiceCreditDatas, setInvoiceCreditDatas] = useState({
        billData: [],
        total: 0
    });
    const [cdFillter, setCdFillter] = useState({
        createdAt_gte: "",
        createdAt_lt: "",
    });
    const [status, setStatus] = useState()
    const [showConfirm, setShowConfirm] = useState({
        showCancel: false,
        showOverView: false
    })
    const [isCurrentModals, setIsCurrentModals] = useState(false)
    const [activeButton, setActiveButton] = useState("thisMonth")
    const [preparData, setPreparData] = useState({ code: '', datas: "" })
    const [dataFilter, setDataFilter] = useState({
        codeNamber: '',
    })
    // let _shopId = localStorage.getItem("SHOP");
    const { _limit, _skip, Pagination_helper } = PaginationHelper();


    // apollo client libarry
    const [getInvoiceCredits, { data: invoiceCredits, loading: loadingInvoiceCredit }] = useLazyQuery(
        GET_INVOICE_CREDITS, { fetchPolicy: "cache-and-network" }
    );
    const [cancelInvoiceCredit, { loading: loadingCancelInvoice }] = useMutation(CANCELED_INVOICE_CREDIT);

    // useEffect Hook
    useEffect(() => {
        if (invoiceCredits) {
            setInvoiceCreditDatas({
                billData: invoiceCredits?.getInvoicesCredits?.billData,
                total: invoiceCredits?.getInvoicesCredits?.total,
            })
        }
    }, [invoiceCredits]);

    useEffect(() => {
        fetchinvoiceCredits()
    }, [status, _skip, dataFilter?.codeNamber, cdFillter])
    
    // create invoice crediting
    const fetchinvoiceCredits = async () => {
        try {
            let _shopId = localStorage.getItem("SHOP");

            if (loadingInvoiceCredit) return;
            let _where = {
                // limit: null,
                // skip: null,
                shopId: _shopId,
                // isDeleted: false
                // orderBy: "createBy_DESC",
            }

            if (!_.isEmpty(status)) {
                _where = {
                    ..._where,
                    status: status
                }
            }

            if (!_.isEmpty(dataFilter?.codeNamber)) {
                _where = {
                    ..._where,
                    code: dataFilter?.codeNamber
                }
            }

            // is current date
            if (!_.isEmpty(cdFillter?.createdAt_gte) && !_.isEmpty(cdFillter?.createdAt_lt)) {
                let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
                let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);
                _where = {
                    ..._where,
                    createdAt_gte: startDateComponents,
                    createdAt_lt: endDateComponents,
                }
            }

            await getInvoiceCredits({
                variables: {
                    where: _where,
                    skip: (_skip - 1) * _limit,
                    limit: _limit,
                },
            });

        } catch (error) {
            console.log("error:", error);
        }
    };

    // handle cnancel invoice credit
    const handleCancelInvoiceCredit = async () => {
        try {
            let _shopId = localStorage.getItem("SHOP");
            if (loadingCancelInvoice) return;
            const res = await cancelInvoiceCredit({
                variables: {
                    where: {
                        shopId: _shopId,
                        code: preparData?.code
                    }
                }
            })
            if (res) {
                fetchinvoiceCredits()
                setShowConfirm({
                    showCancel: false
                })
            }
        } catch (error) {
            console.log("error: ", error)
        }
    }

    // select payment method
    const onSelectStatusInvioces = (e) => {
        let _values = e?.target?.value;
        setStatus(_values);
    };

    // oncancel for get code to udpate
    const onCancelInvoice = (value) => {
        setShowConfirm({
            showCancel: true
        })
        setPreparData({ code: value })
    }

    const handlePreView = (values) => {
        setShowConfirm({
            showOverView: true
        })
        setPreparData({
            datas: values
        })
    }


    return (
        <>

            <Row>
                <Col md={8}>
                    <div>
                        <h3>ບິນແຈ້ງເຄມເງິນ [{invoiceCreditDatas?.total ?? 0}]</h3>
                        <p>ບິນເຄມເງິນທັງໝົດຂອງອໍເດີ້ </p>

                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={7} style={{ display: 'flex', gap: 5, width: '100%', }}>
                    <Form.Group className="mb-3 w-100" controlId="exampleForm.ControlInput1">
                        <Form.Label>ຊອກຫາເລກບິນ</Form.Label>
                        <Form.Control value={dataFilter?.codeNamber} type="text" onChange={(e) => setDataFilter({
                            codeNamber: e?.target?.value
                        })} placeholder="00-00000" />
                    </Form.Group>
                </Col>

                <Col md={3} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>ວັນທີ,ເດືອນ,ປີ</Form.Label>
                        <Button
                            variant="outline-secondary"
                            onClick={() => setIsCurrentModals(true)}
                            style={{ width: "100%", maxWidth: 230, display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

                        >
                            <MdDateRange style={{ fontSize: 25, color: COLOR_TEXT }} />
                            {cdFillter?.createdAt_gte === "" && cdFillter?.createdAt_lt === "" ? (
                                "mm/dd/yyyy"
                            ) : (
                                <>
                                    {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                                </>
                            )}
                        </Button>
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group className="mb-3">
                        <Form.Label>ສະຖານະ</Form.Label>
                        <Form.Select
                            onChange={(e) => onSelectStatusInvioces(e)}
                            aria-label="status select"
                        >
                            <option value="">--ເລືອກທັງໝົດ--</option>
                            {/* <option value="REQUESTING">ກຳລັງຂໍເຄມ</option> */}
                            <option value="APPROVING">ກຳລັງອະນຸມັດ</option>
                            <option value="CANCELED">ຍົກເລີກແລ້ວ</option>
                            <option value="CHECKING">ກຳລັງກວດສອບ</option>
                            <option value="CREATED">ຂໍເຄມເງິນໃໝ່</option>
                            <option value="FINISHED">ສຳເລັດທຸລະກຳ</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            <Card
                className="mb-4"
                style={{ boxShadow: "none", background: COLOR_WHITE }}
            >
                <Card.Body>

                    {(loadingInvoiceCredit && !invoiceCredits) ? (
                        <LoadingSpinner />
                    ) : (
                        <>
                            <div className="claim-responsive-table">
                                <Table>
                                    <thead style={{ borderBottom: "none" }}>
                                        <tr>
                                            <th>
                                                ລຳດັບ
                                            </th>
                                            <th>ເລກທີບິນ</th>
                                            <th>ຈຳນວນບໍລິການ</th>
                                            <th>ເງິນລວມທັງໝົດ</th>
                                            <th>ສະຖານະ</th>
                                            <th>ວັນທີ,ເດືອນ,ປີ ສ້າງ</th>
                                            <th>ໝາຍເຫດ</th>
                                            <th style={{ textAlign: 'right' }}>ຈັດການ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoiceCreditDatas?.billData?.length > 0 ? (
                                            <>
                                                {invoiceCreditDatas?.billData.map((item, index) => (
                                                    <tr
                                                        key={index}
                                                    >
                                                        <td>{index + 1 + _limit * (_skip - 1)}</td>
                                                        <td>{item?.code ?? 0}</td>
                                                        <td>{item?.amount}</td>
                                                        <td>{numberFormat(item?.totalPrice)}</td>
                                                        <td>
                                                            <Badge
                                                                bg={
                                                                    item?.status === "FINISHED"
                                                                        ? "success"
                                                                        : item?.status === "CHECKING"
                                                                            ? "info"
                                                                            : item?.status === "REJECTED"
                                                                                ? "danger"
                                                                                : item?.status === "CANCELED"
                                                                                    ? "secondary"
                                                                                    : item?.status === "APPROVING"
                                                                                        ? "primary"
                                                                                        : item?.status === "CREATED"
                                                                                            ? "warning"
                                                                                            : "light"
                                                                }
                                                            >
                                                                {convertStatusInvoiceClaim(item?.status)}
                                                            </Badge>
                                                        </td>
                                                        <td>{moment(item?.createdAt).format("DD/MM/YYYY HH:mm")}</td>
                                                        <td>-</td>
                                                        <td style={{ display: 'flex', gap: 8, width: '100%', justifyContent: 'end' }}>
                                                            {/* //TODO PhaPay don't have cancel invoice */}
                                                            {/* <Button disabled={item?.status === "CANCELED" ? true : false} variant="outline-danger" onClick={() => onCancelInvoice(item?.code)} ><MdCancel /> ຍົກເລີກ</Button> */}

                                                            <Button variant="info" onClick={() => handlePreView(item)} ><IoMdEye /> ລາຍລະອຽດ</Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        ) : (
                                            <EmptyCredit colSpan={7} />
                                        )}

                                    </tbody>

                                </Table>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                {invoiceCreditDatas?.total > 0 &&
                                    Pagination_helper(invoiceCreditDatas?.total, "/wallet_store", ``)}
                            </div>
                        </>
                    )}
                </Card.Body>
            </Card>

            {/* modeal confirm create */}
            <ModalConfirmComponent
                showConfirmModal={showConfirm.showCancel}
                handleCancel={() => setShowConfirm({ showCancel: false })}
                loadingConfirm={loadingCancelInvoice}
                handleConfirm={handleCancelInvoiceCredit}
                title="ຢືນຢັນ!"
                text="ທ່ານຕ້ອງການຍົກເລີກບິນເຄມເງິນນີ້ບໍ!"
            />

            {/* modal current date  */}
            <CurrentDateModal
                onCloseModal={() => setIsCurrentModals(false)}
                openModal={isCurrentModals}
                setCdFillter={setCdFillter}
                setActiveButton={setActiveButton}
                activeButton={activeButton}
                backdrop={true}
            />

            {/* modal preview invoice credit */}
            <Modal size="lg" show={showConfirm.showOverView} onHide={() => setShowConfirm({ showOverView: false })} animation={false}>
                {/* <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header> */}
                <Modal.Body>
                    <InvoiceDetail preparData={preparData} />
                </Modal.Body>
                <Modal.Footer style={{display:'flex',justifyContent:'space-between'}}>
                    <small>ຂໍຂອບໃຈ ທີ່ໃຊ້ບໍລິການຂອງພວກເຮົາ</small>

                    <Button variant="secondary" onClick={() => setShowConfirm({ showOverView: false })}>
                        ປີດ
                    </Button>

                </Modal.Footer>
            </Modal>
        </>
    );
}
